<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-10 17:47:33
 * @Description: 官网首页
 -->

<template>
  <div class="index-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    let head = document.head || document.getElementByTagName('head')[0] || document.documentElement;
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://s4.cnzz.com/z_stat.php?id=1279001808&web_id=1279001808');
    head.appendChild(script);
    console.log(head);
    script.onload = function() {
      // 执行后续操作。
      console.log('loaded');
    };
  }
};
</script>
<style lang="less" scope></style>
